<template>
    <el-card v-show="isShow()" style="display: flex;align-items: center;padding-top: 18px;">
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item v-for="(item, index) in search" :key="index" :label="item.title">
                <div v-if="item.type == 'text'">
                    <template v-if="item.operate == 'between'">
                        <input-range v-model="item.value" :placeholder="item.props?.placeholder"></input-range>
                    </template>
                    <template v-else>
                        <el-input v-model="item.value" :placeholder="item.props?.placeholder" />
                    </template>
                </div>
                <!-- <div v-if="item.type=='number'">
                    <template v-if="item.operate=='between'">
                        <input-number-range v-model="item.value" :placeholder="item.props?.placeholder"></input-number-range>
                    </template>
                    <template v-else>
                        <el-input-number v-model="item.value" :placeholder="item.props?.placeholder" />
                    </template>
                </div> -->
                <div v-else-if="item.type == 'date'">
                    <template v-if="item.operate == 'range'">
                        <el-date-picker v-model="item.value" type="daterange" unlink-panels :shortcuts="shortcuts"
                            value-format="YYYY-MM-DD" start-placeholder="开始日期" end-placeholder="结束日期"
                            style="width: 100%;"></el-date-picker>
                    </template>
                    <template v-else>
                        <el-date-picker v-model="item.value" type="date" value-format="YYYY-MM-DD"
                            :placeholder="'请选择'"></el-date-picker>
                    </template>
                </div>
                <div v-else-if="item.type == 'datetime'">
                    <template v-if="item.operate == 'range'">
                        <el-date-picker v-model="item.value" :shortcuts="shortcuts" type="datetimerange"
                            value-format="YYYY-MM-DD HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"
                            :placeholder="'请选择'"></el-date-picker>
                    </template>
                    <template v-else>
                        <el-date-picker v-model="item.value" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
                            :placeholder="'请选择'"></el-date-picker>
                    </template>
                </div>
                <div v-else-if="item.type == 'time'">
                    <el-time-picker v-model="item.value" arrow-control :placeholder="'请选择'" />
                </div>
                <div v-else-if="item.type == 'select'">
                    <el-select v-model="item.value" :placeholder="item.props?.placeholder || '请选择'" filterable
                        :multiple="false">
                        <el-option v-for="field in item.options" :key="field.value" :label="field.label"
                            :value="field.value"></el-option>
                    </el-select>
                </div>
                <div v-else-if="item.type == 'cascader'">
                    <el-cascader :props="props" v-model="item.value" :options="item.options" :show-all-levels="false" />
                </div>
                <!-- <div v-else-if="item.type=='radio'">
                    <el-radio-group v-model="item.value">
                        <el-radio v-for="_item in item.options" :key="_item.value" :label="_item.value">{{_item.label}}</el-radio>
                    </el-radio-group>
                </div> -->
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="Search">查询</el-button>
                <el-button @click="Reset">重置</el-button>
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script>
import inputRange from './components/inputRange.vue'
import inputNumberRange from './components/inputNumberRange.vue'
export default {
    props: {
        search: {
            type: Array, default: () => {
                return []
            }
        }
    },
    components: {
        inputRange,
        inputNumberRange
    },
    data() {
        return {
            shortcuts: [
                {
                    text: '近一天',
                    value: () => {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
                        return [start, end]
                    },
                },
                {
                    text: '近一周',
                    value: () => {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                        return [start, end]
                    },
                },
                {
                    text: '近一月',
                    value: () => {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                        return [start, end]
                    },
                },
                {
                    text: '近三个月',
                    value: () => {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                        return [start, end]
                    },
                },
                {
                    text: '近一年',
                    value: () => {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
                        return [start, end]
                    },
                },
            ],
            props:{
                multiple: true,
                value:'id',
                emitPath: false,
                checkStrictly: false
            }
        }
    },
    created() {

    },
    computed: {
        filterObj() {
            const filter = {}
            const op = {}
            this.search.forEach((item) => {
                if (item.value != '') {
                    if (item.operate != 'between' || item.operate == 'between' && item.value != ',') {
                        if (item.type == 'datetime' && item.operate == 'range') {
                            filter[item.field] = item.value.join(' - ')
                            op[item.field] = item.operate
                        } else {
                            filter[item.field] = item.value
                            op[item.field] = item.operate
                        }

                    }
                }
            })
            return { filter, op }
        }
    },
    methods: {
        Search() {
            console.log(this.filterObj);
            this.$emit('handleSearch', this.filterObj);
        },
        Reset() {
            this.search.forEach((item) => {
                item.value = ""
            })
            this.$emit('handleReset', this.filterObj);
        },
        isShow() {
            return this.search.filter(item => {
                return item.type !== 'hidden'
            }).length
        }
    }
}
</script>

<style scoped></style>
